import { render, staticRenderFns } from "./ReleasesProfitAndLossReadOnlyPanel.vue?vue&type=template&id=77422bc1"
import script from "./ReleasesProfitAndLossReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./ReleasesProfitAndLossReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports